import React from 'react';
import PropTypes from 'prop-types';
import { Template, Plugin, Getter, TemplateConnector } from '@devexpress/dx-react-core';
import { TableHeaderRow, Table } from '@devexpress/dx-react-grid-material-ui';
import { IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles/index';

const pluginDependencies = [{ name: 'Table' }, { name: 'RowActionsState' }];
const TABLE_ACTION_TYPE = 'actionsColumnType';

const tableColumnsWithActions = (tableColumns, width) => {
    return [...tableColumns, { key: TABLE_ACTION_TYPE, type: TABLE_ACTION_TYPE, width: width }];
};

const hashRight = (checkHasRight, row) => {
    if (checkHasRight && typeof checkHasRight === 'function') return checkHasRight(row);

    return true;
};
const isHidden = (checkIsHidden, row) => {
    if (checkIsHidden && typeof checkIsHidden === 'function') return checkIsHidden(row);

    return true;
};
export default function RowActions(props) {
    const classes = useStyles(props);
    const { actions, width } = props;
    const tableColumnsComputed = ({ tableColumns }) => tableColumnsWithActions(tableColumns, width);

    return (
        <Plugin name="RowActions" dependencies={pluginDependencies}>
            <Getter name="tableColumns" computed={tableColumnsComputed} />
            <Template
                name="tableCell"
                predicate={({ tableColumn, tableRow }) => tableColumn.type === TABLE_ACTION_TYPE && tableRow.type === TableHeaderRow.ROW_TYPE}
            >
                {params => (
                    <Table.Cell {...params}>
                        <div className={classes.headerCell}>Actions</div>
                    </Table.Cell>
                )}
            </Template>
            <Template
                name="tableCell"
                predicate={({ tableColumn, tableRow }) => tableColumn.type === TABLE_ACTION_TYPE && tableRow.type === Table.ROW_TYPE}
            >
                {params => (
                    <TemplateConnector>
                        {({ loadingRows }, { rowHandleLoading }) => {
                            return (
                                <Table.Cell {...params}>
                                    <div className={classes.rowCell}>
                                        {actions.map((action, index) => {
                                            const actionDisabled = !hashRight(action.hasRight, params.tableRow.row);
                                            const tableRowId = `${params.tableRow.rowId}-${index}`;
                                            const actionHidden = !isHidden(action.isHidden, params.tableRow.row);
                                            if (actionHidden) return null;
                                            return (
                                                <div key={tableRowId}>
                                                    {loadingRows(tableRowId) ? (
                                                        <div className={classes.loadingContainer}>
                                                            <CircularProgress size={20} />
                                                        </div>
                                                    ) : (
                                                        <Tooltip
                                                            row={params.tableRow.row}
                                                            title={action.tooltip}
                                                            placement="top"
                                                            disableHoverListener={actionDisabled}
                                                        >
                                                            <span>
                                                                <IconButton
                                                                    size="small"
                                                                    className="actionIcon"
                                                                    onClick={action.onClick.bind(this, params.tableRow.row, loading =>
                                                                        rowHandleLoading({ tableRowId, loading }),
                                                                    )}
                                                                    disabled={actionDisabled}
                                                                >
                                                                    <action.icon row={params.tableRow.row} />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </Table.Cell>
                            );
                        }}
                    </TemplateConnector>
                )}
            </Template>
        </Plugin>
    );
}
// RowActions.COLUMN_TYPE = RowActions.COLUMN_TYPE;
RowActions.ACTION_TYPE = TABLE_ACTION_TYPE;

RowActions.propTypes = {
    actions: PropTypes.array.isRequired,
    width: PropTypes.number,
};
RowActions.defaultProps = {
    width: 80,
};

const useStyles = makeStyles(() => ({
    headerCell: {
        textAlign: 'center',
    },
    rowCell: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    loadingContainer: {
        marginRight: 5,
    },
}));



// WEBPACK FOOTER //
// ./data/components/pluginsTable/RowActions.js